import React from 'react';
import Icon, { IconName } from './Icon';

/** A device frame around a REAL screenshot of the app. */
export const Phone: React.FC<{ src: string; alt: string; width?: number; hidden?: boolean }> = ({
  src,
  alt,
  width,
  hidden,
}) => (
  <div
    className="phone"
    role={hidden ? undefined : 'img'}
    aria-label={hidden ? undefined : alt}
    aria-hidden={hidden ? true : undefined}
    style={width ? ({ '--pw': `${width}px` } as React.CSSProperties) : undefined}
  >
    <div className="phone__screen">
      <img src={src} alt="" decoding="async" />
    </div>
  </div>
);

/** Stands in for a phone while a screen has no real screenshot yet (e.g. 4.2.7 is not published). */
export const FeatureArt: React.FC<{ icon: IconName; caption: string }> = ({ icon, caption }) => (
  <div className="art" aria-hidden="true">
    <span className="art__disc">
      <Icon name={icon} />
    </span>
    <span className="art__caption">{caption}</span>
  </div>
);
